module.exports = __webpack_public_path__ + "static/img/081021140aqo.0d4e7e15.jpg";